import { useState } from 'react'
import { EmptyObject } from 'type-fest'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_PORTAL_TOKEN } from './api/query'
import { Data } from './api/types'
import { PortalToken, UseGetPortalToken } from './types'

export const useGetPortalToken = (): UseGetPortalToken => {
  const [token, setToken] = useState<PortalToken>()

  const { isLoading: loading } = useQuery<EmptyObject, Data>({
    onCompleted: async (data: Data) => {
      const { portalToken } = data

      setToken(fromDTO(portalToken))
    },
    query: GET_PORTAL_TOKEN,
  })

  return {
    loading,
    token,
  }
}
